import * as React from 'react';
import { SVGProps } from 'react';
const SvgUser = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.286 2C9.44 2 7.127 4.361 7.127 7.263c0 2.902 2.314 5.263 5.159 5.263 2.844 0 5.158-2.36 5.158-5.263C17.444 4.361 15.13 2 12.286 2Zm0 8.421c-1.707 0-3.096-1.417-3.096-3.158 0-1.74 1.39-3.158 3.096-3.158 1.706 0 3.095 1.417 3.095 3.158 0 1.741-1.389 3.158-3.095 3.158ZM21.57 22v-1.053c0-4.062-3.24-7.368-7.222-7.368h-4.127C6.24 13.579 3 16.885 3 20.947V22h2.063v-1.053c0-2.902 2.315-5.263 5.16-5.263h4.126c2.845 0 5.159 2.361 5.159 5.263V22h2.063Z"
      fill="current"
    />
  </svg>
);
export default SvgUser;
